'use client';

import { c as _c } from "react/compiler-runtime";
import { CANAIS, VOLUMES } from '../constants';
import type { UseOnboardingSelfReturn } from '../hooks';
import { WizardFooter } from './WizardFooter';
import { WizardHeader } from './WizardHeader';
interface OperacaoScreenProps {
  vm: UseOnboardingSelfReturn;
}
export const OperacaoScreen = t0 => {
  const $ = _c(29);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm.stepperSteps) {
    t1 = <WizardHeader steps={vm.stepperSteps} />;
    $[0] = vm.stepperSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-3"><h1 className="text-heading-dark text-2xl leading-tight font-semibold text-pretty sm:text-[30px]">Como é a sua operação hoje?</h1><p className="text-label-muted max-w-[420px] text-base leading-relaxed text-pretty">Duas perguntas rápidas. Elas definem o tamanho do plano que vamos sugerir depois — e nada mais.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <legend className="text-heading-dark text-sm font-semibold">Quantos casos você trata por mês?</legend>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== vm) {
    t4 = VOLUMES.map(opcao => {
      const selecionado = vm.volume === opcao.id;
      return <button key={opcao.id} type="button" role="radio" aria-checked={selecionado} onClick={() => vm.escolherVolume(opcao.id)} className={`focus-visible:ring-brand-600/20 flex cursor-pointer items-center gap-3 rounded-[12px] border border-solid px-4 py-3.5 text-left transition-all duration-200 focus-visible:ring-4 focus-visible:outline-none ${selecionado ? "border-brand-600 bg-brand-50 border-2" : "border-neutral-200 bg-white hover:border-neutral-300 hover:bg-neutral-50"}`}><span className={`flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full border border-solid transition-colors ${selecionado ? "border-brand-600 bg-brand-600" : "border-neutral-300 bg-white"}`}>{selecionado && <span className="h-1.5 w-1.5 rounded-full bg-white" />}</span><span className="flex flex-col gap-0.5"><span className="text-heading-dark text-sm font-semibold">{opcao.label}</span><span className="text-xs text-neutral-500">{opcao.nota}</span></span></button>;
    });
    $[4] = vm;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <fieldset className="flex flex-col gap-3 border-0 p-0">{t3}<div className="grid grid-cols-1 gap-3 sm:grid-cols-2">{t4}</div></fieldset>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <legend className="text-heading-dark text-sm font-semibold">Como você conheceu a Arbitralis?</legend>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== vm) {
    t7 = CANAIS.map(t8 => {
      const {
        id,
        label
      } = t8;
      const selecionado_0 = vm.canal === id;
      return <button key={id} type="button" aria-pressed={selecionado_0} onClick={() => vm.escolherCanal(id)} className={`focus-visible:ring-brand-600/20 flex h-9 cursor-pointer items-center rounded-full border-solid px-4 text-[13px] font-medium transition-all duration-200 focus-visible:ring-4 focus-visible:outline-none ${selecionado_0 ? "border-brand-600 bg-brand-50 text-brand-700 border-[1.5px]" : "border border-neutral-200 bg-white text-neutral-700 hover:bg-neutral-50"}`}>{label}</button>;
    });
    $[9] = vm;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <fieldset className="flex flex-col gap-3 border-0 p-0">{t6}<div className="flex flex-wrap gap-2.5">{t7}</div></fieldset>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-14"><div className="grid w-full max-w-[1280px] grid-cols-1 gap-10 lg:grid-cols-[minmax(280px,1fr)_minmax(420px,1.85fr)] lg:gap-20">{t2}<div className="flex flex-col gap-8">{t5}{t8}</div></div></div>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== vm) {
    t10 = () => vm.goTo("produtos");
    $[16] = vm;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== vm.pularECriarConta) {
    t11 = <button type="button" onClick={vm.pularECriarConta} className="text-[13px] font-medium text-neutral-500 underline transition-colors hover:text-neutral-700">Pular</button>;
    $[18] = vm.pularECriarConta;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== vm.criandoConta || $[23] !== vm.criarConta) {
    t12 = <WizardFooter voltarLabel="Voltar" onVoltar={t10} avancarLabel="Criar minha conta" onAvancar={vm.criarConta} avancarLoading={vm.criandoConta} aoLadoDoAvancar={t11} />;
    $[20] = t10;
    $[21] = t11;
    $[22] = vm.criandoConta;
    $[23] = vm.criarConta;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t1 || $[26] !== t12 || $[27] !== t9) {
    t13 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t9}{t12}</div>;
    $[25] = t1;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};